import '@fpsm/cxy-tokens/tokens.css';

import { CxFooterLean } from '@cx-web/components/composites';
import { type FooterV2Response } from '@cx-web/domain-types';
import { useLoaderData } from '@remix-run/react';

import { type Logos } from '~/routes/$/constants/logos';

import type { loader } from '../../loader.server';
import { LogoImage } from '../LogoImage/LogoImage';

import styles from './LandingPageFooter.module.css';

export type LandingPageFooterProps = {
  footerData?: FooterV2Response;
  logo: Logos;
};

export const LandingPageFooter = ({ footerData, logo }: LandingPageFooterProps) => {
  const { resourcesUrl } = useLoaderData<typeof loader>();

  return (
    <div className={styles.wrapper}>
      <div className={styles.divider}>
        <div />
      </div>
      <CxFooterLean
        footerData={footerData}
        isAdmiralCookieBannerEnabled={false}
        logo={<LogoImage logoName={logo} resourcesUrl={resourcesUrl} />}
      />
    </div>
  );
};
